import React, { FC } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

export const UpliftTooltip: FC = ({ children }) => (
  <Tooltip
    title="The uplifts you have selected have been automatically applied as an increase in your time-based calculations. The client proposal will show the uplifted fee total but not the uplift amount or the rationale for the uplift."
    placement="left"
  >
    <InfoCircleOutlined style={{ marginRight: 5 }} />
    {children}
  </Tooltip>
);
